export enum PlayerStatusEnum {
    PLAY = 'PLAY',
    STOP = 'STOP'
}

export enum SpeedMultiplierEnum {
    SPEED05 = "speed05",
    SPEED1 = "speed1",
    SPEED2 = "speed2",
}


// WEBPACK FOOTER //
// ./src/components/History/CollisionTimeLine/CollisionTimeLineEnums.ts